import Icon from '../components/Icon.vue'

Icon.register({
  'map-marker-alt': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M172.3 501.7C27 291 0 269.4 0 192 0 86 86 0 192 0S384 86 384 192C384 269.4 357 291 211.7 501.7 202.2 515.4 181.8 515.4 172.3 501.7zM192 272C236.2 272 272 236.2 272 192S236.2 112 192 112 112 147.8 112 192 147.8 272 192 272z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/map-marker-alt.js
// module id = pVAv
// module chunks = 144